import { render, staticRenderFns } from "./CustomSlider.vue?vue&type=template&id=792730de&scoped=true&"
import script from "./CustomSlider.vue?vue&type=script&lang=js&"
export * from "./CustomSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792730de",
  null
  
)

export default component.exports